/* eslint-disable react/require-default-props */
import { InputHTMLAttributes, useState } from 'react';
import { FaRegEyeSlash } from 'react-icons/fa';
import { IoEyeOutline } from 'react-icons/io5';

interface InputProperties extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  label?: string;
  error?: string;
  onChange: (value: string) => void;
  containerClassName?: string;
  labelClassName?: string;
  inputClassName?: string;
  disabled?: boolean;
  showTogglePassword?: boolean;
}

export default function InputField({
  showTogglePassword,
  label,
  error,
  onChange,
  containerClassName = '',
  labelClassName = '',
  disabled = false,
  inputClassName = 'h-[49px] w-[378px] rounded-xl text-shadow border-[1.64px] px-4 py-2 text-s1 placeholder:text-xs font-semibold focus:outline-none shadow-custom-blue',
  ...properties
}: InputProperties) {
  const onHandleChange = (event_: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event_.target.value);
  };
  const [showPassword, setShowPassword] = useState(false);

  const getErrorText = (text: string) => {
    return (
      <div className="mt-2 flex items-center">
        <img src="./icons/error-icon.svg" alt="error icon" />
        <span className="ml-2 text-xs1 text-error-red-3">{text}</span>
      </div>
    );
  };

  const labelSx = disabled
    ? 'text-neutral-grey-2 text-s1 mb-1 block font-medium'
    : 'text-neutral-grey-3 text-s1 mb-1 block font-medium';
  const errorSx =
    'border-error-red-3 text-error-red-3 focus:border-error-red-3 focus:ring-error-red-3';
  const notErrorSx =
    'border-neutral-grey-3 text-neutral-grey-4 placeholder-neutral-grey-3 focus:border-secondary-blue-2 focus:ring-secondary-blue-2';
  const disabledSxInput = 'border-neutral-grey-2 text-neutral-grey-2 placeholder-neutral-grey-2 ';
  const passwordInputSx = showTogglePassword ? 'pr-10' : '';

  const getInputClassName = () => {
    const baseClass = inputClassName;
    let stateClass = error ? errorSx : notErrorSx;
    if (disabled) {
      stateClass = disabledSxInput;
    }
    return `${baseClass} ${stateClass} ${passwordInputSx}`;
  };

  const onTogglePasswordVisibility = () => {
    setShowPassword((show) => !show);
  };

  const renderPasswordToggle = () => (
    <button
      type="button"
      onClick={onTogglePasswordVisibility}
      className="absolute right-1 top-10 flex cursor-pointer items-center pr-2"
    >
      {showPassword ? (
        <IoEyeOutline style={{ color: '#999999', fontSize: '1.1em' }} />
      ) : (
        <FaRegEyeSlash style={{ color: '#999999', fontSize: '1.1em' }} />
      )}
    </button>
  );

  return (
    <div className={`relative ${containerClassName}`}>
      {label && (
        <label htmlFor={properties.id} className={`${labelClassName} ${labelSx} `}>
          {label}
        </label>
      )}
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...properties}
        type={showPassword ? 'text' : properties.type}
        disabled={disabled}
        onChange={onHandleChange}
        className={getInputClassName()}
      />
      {error && getErrorText(error)}
      {showTogglePassword && renderPasswordToggle()}
    </div>
  );
}
